import { skeletonColor } from 'constant';

import { Skeleton, useTheme, VStack } from '@chakra-ui/react';

const ProductShopGridSkeleton = () => {
  const {
    colors: {
      palette: {
        shop: {
          products: {
            listStep: {
              listContainer: { container: styles }
            }
          }
        }
      }
    }
  } = useTheme();

  return (
    <VStack gap={0} w='full' borderRadius='3px' overflow='hidden' shadow='sm'>
      <Skeleton
        variant='pulse'
        borderRadius={0}
        w='full'
        aspectRatio='1/1'
        fadeDuration={0.8}
        startColor={skeletonColor.start}
        endColor={skeletonColor.end}
      />
      <VStack
        bg={styles.productBg}
        w='full'
        px='20px'
        pt='23px'
        pb='20px'
        gap='8px'
        flex={1}
        justifyContent='space-between'
      >
        <VStack w='full' gap='6px'>
          <Skeleton
            w='full'
            height='22px'
            variant='shine'
            startColor={skeletonColor.start}
            endColor={skeletonColor.end}
          />
          <Skeleton
            w='50%'
            height='17px'
            variant='shine'
            startColor={skeletonColor.start}
            endColor={skeletonColor.end}
          />
        </VStack>

        <VStack w='full' justifyContent='center'>
          <Skeleton
            w='70px'
            height='19px'
            variant='shine'
            mt='4px'
            startColor={skeletonColor.start}
            endColor={skeletonColor.end}
          />
        </VStack>
      </VStack>
    </VStack>
  );
};

export default ProductShopGridSkeleton;
